import Contacto from "./contacto/contacto"
import styles from './contactoMain.module.css'

function ContactoMain() {
    return(
        <section id="contacto" className={styles.contactoMain}>
            <Contacto></Contacto>
        </section>
    )
}


export default ContactoMain